// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox__1QD_b","buttons":"buttons__2LvSG"};